export default "__VITE_PUBLIC_ASSET__ca4e7a8d__"